import UsersPromoCodeResponse from '../../../../../Spirit/Admin/Interfaces/Models/PromoCodeService/UsersPromoCodeResponse';

export default class PromoCodeGetDetailResponse  {
	Id?: number = null;
	Code?: string = '';
	PremiumDays: number = 0;
	IsSingleUse: boolean = false;
	ExpirationDate: Date = null;
	Users: Array<UsersPromoCodeResponse> = null;
	constructor(obj?: Partial<PromoCodeGetDetailResponse>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
